var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 0H2C0.89543 0 0 0.895431 0 2V7.33333C0 8.4379 0.89543 9.33333 2 9.33333H12.6667C13.7712 9.33333 14.6667 8.4379 14.6667 7.33333V2C14.6667 0.895431 13.7712 0 12.6667 0ZM2.66667 4.66667C2.66667 4.29848 2.96514 4 3.33333 4C3.70152 4 4 4.29848 4 4.66667C4 5.03486 3.70152 5.33333 3.33333 5.33333C2.96514 5.33333 2.66667 5.03486 2.66667 4.66667ZM10.6667 4.66667C10.6667 4.29848 10.9651 4 11.3333 4C11.7015 4 12 4.29848 12 4.66667C12 5.03486 11.7015 5.33333 11.3333 5.33333C10.9651 5.33333 10.6667 5.03486 10.6667 4.66667ZM12.6667 8C13.0349 8 13.3333 7.70152 13.3333 7.33333V2C13.3333 1.63181 13.0349 1.33333 12.6667 1.33333H2C1.63181 1.33333 1.33333 1.63181 1.33333 2V7.33333C1.33333 7.70152 1.63181 8 2 8H12.6667ZM7.33333 2.66667C6.22876 2.66667 5.33333 3.5621 5.33333 4.66667C5.33333 5.77124 6.22876 6.66667 7.33333 6.66667C8.4379 6.66667 9.33333 5.77124 9.33333 4.66667C9.33333 3.5621 8.4379 2.66667 7.33333 2.66667ZM6.66667 4.66667C6.66667 5.03486 6.96514 5.33333 7.33333 5.33333C7.70152 5.33333 8 5.03486 8 4.66667C8 4.29848 7.70152 4 7.33333 4C6.96514 4 6.66667 4.29848 6.66667 4.66667Z",
    fill: "#2E5DE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBill);
export default __webpack_public_path__ + "static/media/cash-bill.954287a676deabc9e64e619014715f65.svg";
export { ForwardRef as ReactComponent };